import type { VerifyResponse } from '@dynamic-labs/sdk-api-core';

import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';
import { createApiClient } from '../../apiClient';
import { updateAuthFromVerifyResponse } from '../../auth/updateAuthFromVerifyResponse';
import { emitEvent } from '../../clientEvents';

const DEVICE_REGISTRATION_TOKEN_HEADER = 'x-dynamic-device-registration-token';

type CompleteDeviceRegistrationParams = {
  deviceToken: string;
};

export const completeDeviceRegistration = async (
  { deviceToken }: CompleteDeviceRegistrationParams,
  client = getDefaultClient()
): Promise<VerifyResponse> => {
  assertDefined(deviceToken, 'deviceToken is required');

  const core = getCore(client);
  const apiClient = createApiClient(
    {
      headers: {
        [DEVICE_REGISTRATION_TOKEN_HEADER]: deviceToken,
      },
    },
    client
  );

  const response = await apiClient.deviceRegistration({
    environmentId: core.environmentId,
  });

  updateAuthFromVerifyResponse({ response }, client);

  // Emit event after successful registration
  emitEvent({ event: 'deviceRegistrationCompleted' }, client);

  return response;
};
